module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_1_null@2x.ab9c2376.png";